import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '../../../common/Alert/Alert';
import { MEDIA_SERVER_ERROR_CODE } from '../../../NetworkTestWidget/Tests/Tests.constants';
import { TestResults } from '../../../types';
import { getConnectivityAlertVariant, getDocumentationLink } from '../../../utils';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    links: {
      textDecoration: 'none',
    },
  });
});

const CheckConnecitivityResults = ({ results }: { results: TestResults }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const { results: connectivitiyResults, errors: connectivityErrors } = results;

  return (
    <Box padding={2}>
      <Alert variant={getConnectivityAlertVariant(results)}>
        <Typography variant="body1">
          <strong>
            {!connectivitiyResults?.preflight && connectivityErrors.preflight?.code !== MEDIA_SERVER_ERROR_CODE ? (
              <>
                {t('TEST_FAILURE.SIGNALLING_SERVER_1')} {t('TEST_FAILURE.CLICK_HERE')}
                <a className={classes.links} target="_blank" rel="noreferrer" href={getDocumentationLink(results)[0]}>
                  {t('TEST_FAILURE.HERE')}
                </a>
                {t('TEST_FAILURE.SIGNALLING_SERVER_2')}
                <a className={classes.links} target="_blank" rel="noreferrer" href={getDocumentationLink(results)[1]}>
                  {t('TEST_FAILURE.HERE')}
                </a>
                {t('TEST_FAILURE.SIGNALLING_SERVER_3')}
              </>
            ) : (
              <>
                {connectivityErrors.preflight?.code === MEDIA_SERVER_ERROR_CODE ? (
                  <>
                    {t('TEST_FAILURE.MEDIA_SERVER')} {t('TEST_FAILURE.CLICK_HERE')}
                    <a className={classes.links} target="_blank" rel="noreferrer" href={getDocumentationLink(results)}>
                      {t('TEST_FAILURE.HERE')}
                    </a>
                    {t('TEST_FAILURE.MORE_INFORMATION')}
                  </>
                ) : (
                  <> {t('TEST_SUCCESSFUL.CONNECTIVITY_TEST')}</>
                )}
              </>
            )}
          </strong>
        </Typography>
      </Alert>
    </Box>
  );
};

export { CheckConnecitivityResults };
